import React, { Component } from "react";

// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Alert,
  Col,
  Button,
  CardFooter,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { Link } from "react-router-dom";

import API, { base } from "api.js";
import SimpleReactValidator from "simple-react-validator";
import { setAlert } from "action/index.js";
import { NavLink } from "react-router-dom";
import { setUser } from "action/index.js";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import { store, persistor } from "store/index";
import { connect } from "react-redux";
import { thead, tbody } from "variables/general";
import { CountryRegionData } from "react-country-region-selector";
import Select from "react-select";
import DeleteUser from "components/Profile/DeleteUser";
import SidebarClose from "components/Sidebar/SidebarClose";
import { timeZonesNames } from "@vvo/tzdb";

const timezones = timeZonesNames.map((timezone) => (
  {
    label: timezone,
    value: timezone,
  }
));

timezones.unshift({
  label: "Auto detect",
  value: "Auto detect"
})

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (user) => dispatch(setUser(user)),
  };
};
class Mock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      activeTab: 1,
      userName: "",
      first_name: null,
      last_name: null,
      country_citizenship: null,
      country_residence: null,
      countryState: "",
      dob: null,
      email: null,
      phone: null,
      address: null,
      lang: "",
      center: null,
      score: "",
      image: "",
      image_src: "",
      error_bag: null,
      modal: false,
      imgModal: false,
      selectArr: [],
      subscriptionId: null,
      name: "",
      countries: [],
      states: [],
      selectedCountryStates: [],
      imageError: "",
      subscription: null,
      timezone: "",
    };
    this.validator = new SimpleReactValidator();
  }

  changeInput = (e) => {
    let { name, value } = e.target;
    this.setState({ [name]: value });
  };

  componentDidMount() {
    let selectArr = [];
    if (store.getState().is_main) {
      selectArr = [
        "LA Parramatta Branch",
        "LA Sydney CBD Branch",
        "LA Jalandhar Branch",
        "LA Online Student",
        "LA Gurdaspur Branch",
        "LA Amritsar Branch",
        "LA Sirsa Branch",
        "LA Sri Ganganagar Branch",
        "LA Kurukshetra Branch",
        "LA Barnala Branch",
        "LA Butwal (Nepal)",
        "Not a student with LA",
      ];
    } else {
      selectArr = selectArr = ["Not a student with LA"];
    }
    this.setState({ selectArr: selectArr });
    API({
      method: "GET",
      url: "user-my-profile",
    })
      .then((data) => {
        var first_name = data.data.user.first_name;
        var last_name = data.data.user.last_name;
        var country_citizenship = data.data.user.country_citizenship;
        var country_residence = data.data.user.country_residence;
        var country_state = data.data.user.country_state;
        var dob = data.data.user.dob;
        var email = data.data.user.email;
        var phone = data.data.user.phone;
        var address = data.data.user.address;
        var lang = data.data.user.lang;
        var center = data.data.user.center;
        var score = data.data.user.score;
        var image_src = data.data.user.image;
        const subscription =
          data.data.user.active_subscription.length > 0
            ? data.data.user.active_subscription[0]
            : null;
        const name = last_name ? `${first_name} ${last_name}` : first_name;
        let tz = "";
        if(data.data.user.user_timezone) {
          tz = data.data.user.user_timezone.timezone;
        }

        this.setState({
          name: name,
          first_name: first_name,
          last_name: last_name,
          country_citizenship: country_citizenship,
          country_residence: country_residence,
          countryState: country_state,
          dob: dob,
          email: email,
          phone: phone,
          address: address,
          lang: lang,
          center: center,
          score: score,
          image_src: image_src,
          subscription,
          timezone: tz
        });
        if (data.data.user.active_subscription[0]) {
          this.setState({
            subscriptionId:
              data.data.user.active_subscription[0].stripe_subscription_id,
          });
          // const subscription = data.data.user.active_subscription[0];
          // this.props.setUser({...this.props.user, active_subscription: subscription})
        }

        // setTimeout(function(){
        //   document.querySelector('select[name="lang"]').value= lang;
        //   document.querySelector('select[name="center"]').value= center;
        //   document.querySelector('select[name="score"]').value= score;
        // },100);
        let selected = CountryRegionData.filter((value) => {
          return value[0] === country_residence;
        });
        const statesString = selected[0][2];
        const statesArray = statesString
          .split("|")
          .map((state) => state.split("~")[0]);
        const states = statesArray.map((value) => {
          return {
            label: value,
            value: value,
          };
        });
        this.setState({ states: states });
      })
      .catch(() => {});

    const countriesArr = CountryRegionData.map((value) => {
      return {
        label: value[0],
        value: value,
      };
    });
    countriesArr.sort(this.compareCountries);
    this.setState({ countries: countriesArr });
  }

  compareCountries(a, b) {
    const topCountries = ["India", "Australia", "Pakistan"];
    // console.log(topCountries);
    const aIndex = topCountries.indexOf(a.label);
    const bIndex = topCountries.indexOf(b.label);

    // If both countries are in the topCountries array, sort based on their order
    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex;
    }

    // If only one country is in the topCountries array, prioritize it
    if (aIndex !== -1) {
      return -1; // Move a to the top
    }
    if (bIndex !== -1) {
      return 1; // Move b to the top
    }

    // If neither country is in the topCountries array, maintain original order
    return 0;
  }

  selectCountry(val) {
    this.setState({ country_citizenship: val });
  }

  selectCountryResidence(val) {
    console.log(val);
    this.setState({ country_residence: val.label, countryState: "" });
    const statesString = val.value[2];
    const statesArray = statesString
      .split("|")
      .map((state) => state.split("~")[0]);
    const states = statesArray.map((value) => {
      return {
        label: value,
        value: value,
      };
    });
    console.log(states);
    this.setState({ states: states });
  }

  selectRegion(val) {
    this.setState({ countryState: val.label });
  }

  selectTimezone(val) {
    this.setState({timezone: val});
  }

  selectAvatar = async (av) => {
    var bodyFormData = new FormData();
    bodyFormData.append("email", this.state.email);
    bodyFormData.append("avatarImage", av);
    let res = null;
    try {
      res = await API({
        method: "POST",
        url: "/saveUser",
        data: bodyFormData,
      });
    } catch (error) {
      this.setState({ error: { error } });
    }
    console.log(res.status);
    if (res.status === 200) {
      this.props.setUser(res.data.response.user);
      store.dispatch(
        setAlert({ flag: true, type: 1, message: res.data.response.message })
      );
      this.openModal();
      window.location.reload();
    } else if (res.response.status === 422) {
      this.setState({ error: res.response });
      let str = "";
      Object.values(this.state.error.data.errors).forEach((val) => {
        str += val[0] + "\n";
      });
      this.setState({ error_bag: str });
    }
  };
  postSignUp = async (e) => {
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
      return false;
    }
    this.setState({ error_bag: null });
    e.preventDefault();
    var bodyFormData = new FormData();
    bodyFormData.append("phone", this.state.phone);
    bodyFormData.append("first_name", this.state.name);
    // bodyFormData.append('last_name', null);
    if (this.state.dob !== null) {
      bodyFormData.append("dob", this.state.dob);
    }
    // bodyFormData.append('center', this.state.center);
    bodyFormData.append("score", this.state.score);
    bodyFormData.append("lang", this.state.lang);
    let tz;
    if(this.state.timezone === "Auto detect") {
      tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } else {
      tz = this.state.timezone;
    }
    bodyFormData.append('timezone', tz);
    bodyFormData.append("email", this.state.email);
    if (this.state.image) {
      bodyFormData.append("image", this.state.image);
    }

    bodyFormData.append("country_citizenship", this.state.country_residence);
    bodyFormData.append("country_residence", this.state.country_residence);
    bodyFormData.append("country_state", this.state.countryState);
    let res = null;
    try {
      res = await API({
        method: "POST",
        url: "/saveUser",
        data: bodyFormData,
      });
    } catch (error) {
      this.setState({ error: { error } });
    }

    if (res.status === 200) {
      this.props.setUser(res.data.response.user);
      store.dispatch(
        setAlert({ flag: true, type: 1, message: res.data.response.message })
      );
      window.location.href = "/admin/dashboard";
    } else if (res.response.status === 422) {
      this.setState({ error: res.response });
      let str = "";
      Object.values(this.state.error.data.errors).forEach((val) => {
        str += val[0] + "\n";
      });
      this.setState({ error_bag: str });
    }
  };

  onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];

      const allowedTypes = ["image/jpeg", "image/png", "image/gif"];
      if (!allowedTypes.includes(img.type)) {
        this.setState({
          imageError: "Unsupported file type. Please upload a valid image.",
        });
        event.target.value = null; // Clear the input
        return;
      }

      const maxSize = 2 * 1024 * 1024; // 2MB
      if (img.size > maxSize) {
        this.setState({ imageError: "File size exceeds the limit (2MB)." });
        event.target.value = null; // Clear the input
        return;
      }

      this.setState({
        image: img,
        imageError: "",
      });
    }
  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  cancelSub = () => {
    // this.setState({modal:true});
    this.props.history.push("/admin/subscription-detail");
  };

  openModal = () => {
    this.setState({ imgModal: !this.state.imgModal });
  };

  cancelSubAction = (t) => {
    if (t) {
      this.cancelSubApi();
    }
    this.setState({ modal: false });
  };

  cancelSubApi = () => {
    var bodyFormData = new FormData();
    bodyFormData.set("user_id", this.state.dob);
    bodyFormData.set("stripe_subscription_id", this.state.subscriptionId);
    API({
      method: "POST",
      url: "cancel/sub",
      data: bodyFormData,
    })
      .then((data) => {
        if ("status" in data) {
          this.props.setUser(data.data.user);
          store.dispatch(
            setAlert({ flag: true, type: 1, message: data.data.message })
          );
        } else {
          store.dispatch(
            setAlert({ flag: true, type: 2, message: "Something went wrong" })
          );
        }
      })
      .catch((error) => {
        store.dispatch(
          setAlert({ flag: true, type: 2, message: "Something went wrong" })
        );
      });
  };

  render() {
    const { subscription } = this.state;
    const showSubBtn = subscription && subscription.is_recurring_plan !== 0;

    let detectedTimezone;
    if(this.state.timezone === "Auto detect") {
      detectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    return (
      <>
        {this.state.modal && (
          <Modal isOpen={this.state.modal} size="sm">
            <ModalBody>
              <div>Do you want to cancel subscription ?</div>
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                className="modalCloseBtn"
                onClick={(e) => {
                  this.cancelSubAction(1);
                }}
              >
                Yes
              </Button>
              <Button
                color="secondary"
                className="modalCloseBtn"
                onClick={(e) => {
                  this.cancelSubAction(0);
                }}
              >
                No
              </Button>
            </ModalFooter>
          </Modal>
        )}
        {this.state.imgModal && (
          <Modal isOpen={this.state.imgModal} size="sm">
            <ModalBody>
              <div className="row">
                <div className="col-md-6">
                  <img style={{ width: "100px" }} src="/images/female.png" />
                  <div>
                    <span
                      onClick={(e) => {
                        this.selectAvatar("/storage/female.png");
                      }}
                      className="mt-3 btn btn-success"
                    >
                      Select
                    </span>
                  </div>
                </div>
                <div className="col-md-6">
                  <img style={{ width: "100px" }} src="/images/male.png" />
                  <div>
                    <span
                      onClick={(e) => {
                        this.selectAvatar("/storage/male.png");
                      }}
                      className="mt-3 btn btn-success"
                    >
                      Select
                    </span>
                  </div>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                className="modalCloseBtn"
                onClick={(e) => {
                  this.openModal();
                }}
              >
                Close
              </Button>
            </ModalFooter>
          </Modal>
        )}
        <div className="content">
          <SidebarClose />
          <Row>
            <Col xs={12}>
              <Card>
                <CardHeader>
                  {this.state.error_bag && (
                    <Alert color="warning">{this.state.error_bag}</Alert>
                  )}
                  <CardTitle tag="h4">
                    My Profile
                    <Link to="password" className="float-right change-password">
                      Change Password
                    </Link>
                  </CardTitle>
                  <small>* indicates a required field.</small>
                </CardHeader>

                <CardBody>
                  <div className="profileOuter">
                    <div className="cancel_sub_div">
                      {/* {store.getState().is_main && this.state.subscriptionId && this.state.subscriptionId !== "sub_demo" && <button className="btn1 btn-danger" onClick={(e)=>{this.cancelSub()}}>Cancel Subscription</button>}
                {store.getState().is_main && this.state.subscriptionId && this.state.subscriptionId !== "sub_demo" && <span className="cancelsubscriptionspan">If cancelled now, you won’t have the subscription access from that moment!</span>} */}
                      <DeleteUser />
                      {store.getState().is_main &&
                        showSubBtn &&
                        this.state.subscriptionId &&
                        this.state.subscriptionId !== "sub_demo" &&
                        this.state.subscriptionId !==
                          "backend_subscription" && (
                          <>
                            <button
                              className="btn1 btn-danger"
                              onClick={(e) => {
                                this.cancelSub();
                              }}
                            >
                              Cancel Subscription
                            </button>
                            {/* <span className="cancelsubscriptionspan">If cancelled now, you won’t have the subscription access from that moment!</span> */}
                          </>
                        )}
                    </div>
                    <Form>
                      <Row>
                        <Col className="" md="6" sm="12">
                          <FormGroup>
                            <label>Name*</label>
                            <Input
                              defaultValue={this.state.name}
                              name="name"
                              placeholder="Name"
                              type="text"
                              onChange={(e) => {
                                this.changeInput(e);
                              }}
                            />
                            {this.validator.message(
                              "name",
                              this.state.name,
                              "required"
                            )}
                          </FormGroup>
                        </Col>
                        {/* <Col className="" md="3" sm="12">
                        <FormGroup>
                          <label>Last Name</label>
                          <Input
                            defaultValue={this.state.last_name}
                            name="last_name"
                            placeholder="Last Name"
                            type="text"
                            onChange={(e) => { this.changeInput(e)} }
                          />
                          {this.validator.message('last name', this.state.last_name, 'required')}
                        </FormGroup>
                      </Col> */}
                        <Col className="" md="6" sm="12">
                          <FormGroup>
                            <label>Phone*</label>
                            <Input
                              defaultValue={this.state.phone}
                              name="phone"
                              placeholder="Phone"
                              type="text"
                              onChange={(e) => {
                                this.changeInput(e);
                              }}
                            />
                            {this.validator.message(
                              "phone",
                              this.state.phone,
                              "required"
                            )}
                          </FormGroup>
                        </Col>
                        {/* <Col className="" md="4" sm="12">
                        <FormGroup>
                          <label>D.O.B.</label>
                          <Input
                            defaultValue={this.state.dob}
                            placeholder="dob"
                            name="dob"
                            type="date"
                            onChange={(e) => { this.changeInput(e)} }
                          />
                          {this.validator.message('date of birth', this.state.dob, 'required')}
                        </FormGroup>
                      </Col> */}
                      </Row>
                      <Row>
                        {/* <Col className="" md="4" sm="12">
                        <FormGroup>
                          <label>Country of citizenship</label>
                          <CountryDropdown
                            value={this.state.country_citizenship}
                            onChange={(val) => this.selectCountry(val)} className="form-control" name="country_citizenship"/>
                          {this.validator.message('country of citizenship', this.state.country_citizenship, 'required')}
                        </FormGroup>
                      </Col> */}
                        <Col className="" md="6" sm="12">
                          <FormGroup>
                            <label>Country of residence*</label>
                            {/* <CountryDropdown
                            value={this.state.country_residence}
                            onChange={(val) => this.selectCountryResidence(val)} className="form-control" name="country_residence"/>*/}
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              placeholder="Search Country"
                              value={this.state.countries.filter((option) => {
                                return (
                                  option.label === this.state.country_residence
                                );
                              })}
                              isSearchable={true}
                              name="country_residence"
                              options={this.state.countries}
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                              onChange={(val) =>
                                this.selectCountryResidence(val)
                              }
                            />
                            {this.validator.message(
                              "country of residence",
                              this.state.country_residence,
                              "required"
                            )}
                          </FormGroup>
                        </Col>
                        <Col className="" md="6" sm="12">
                          <FormGroup>
                            <label>State (of Country of residence)*</label>
                            {/* <RegionDropdown
                            country={this.state.country_residence}
                            value={this.state.countryState}
                            onChange={(val) => this.selectRegion(val)} className="form-control" name="countryState"/> */}
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              placeholder="Search State"
                              value={this.state.states.filter(
                                (option) =>
                                  option.label === this.state.countryState
                              )}
                              isSearchable={true}
                              name="countryState"
                              options={this.state.states}
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                              onChange={(val) => this.selectRegion(val)}
                            />
                            {this.validator.message(
                              "state",
                              this.state.countryState,
                              "required"
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="" md="4" sm="12">
                          <FormGroup>
                            <label>Default Language</label>
                            <select
                              className="form-control"
                              name="lang"
                              onChange={(e) => {
                                this.changeInput(e);
                              }}
                              value={this.state.lang}
                            >
                              <option value="en-GB">en-GB</option>
                              <option value="en-US">en-US</option>
                            </select>
                          </FormGroup>
                        </Col>
                        {/* <Col className="" md="4">
                        <FormGroup>
                          <label>Select Branch</label>
                          <select className="form-control" onChange={(e) => { this.changeInput(e)} } name="center" value={this.state.center}>
                            <option value="null">Not Applicable</option>
                            {this.state.selectArr.length > 0 && this.state.selectArr.map((v,key)=>{
                              return (<option value={v} key={key}>{v}</option>);
                            })}
                          </select>
                           {this.validator.message('branch', this.state.center, 'required')}
                           <em className="info-txt">*this information must be 100% appropriate otherwise your account may be blocked</em>
                        </FormGroup>
                      </Col> */}
                        <Col className="" md="4" sm="12">
                          <FormGroup>
                            <label>Desired score</label>
                            <select
                              className="form-control"
                              onChange={(e) => {
                                this.changeInput(e);
                              }}
                              name="score"
                              value={this.state.score}
                            >
                              <option value="null">Select desired score</option>
                              <option value="36">36+ (5 Bands)</option>
                              <option value="42">42+ (5.5 Bands)</option>
                              <option value="50">50+ (6 Bands)</option>
                              <option value="58">58+ (6.5 Bands)</option>
                              <option value="65">65+ (7 Bands)</option>
                              <option value="73">73+ (7.5 Bands)</option>
                              <option value="79">79+ (8 Bands)</option>
                            </select>
                          </FormGroup>
                        </Col>
                        <Col md="4" sm="12">
                          <FormGroup>
                            <label htmlFor="">Timezone</label>
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              placeholder="Search Timezone"
                              value={{label: this.state.timezone, value: this.state.timezone}}
                              isSearchable={true}
                              name="timezone"
                              options={timezones}
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                              onChange={(val) => this.selectTimezone(val.value)}
                            />
                            {detectedTimezone}
                            {this.validator.message(
                              "timezone",
                              this.state.timezone,
                              "required"
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="" md="4">
                          <FormGroup>
                            <label>Profile image</label>
                            <Input
                              defaultValue={this.state.image}
                              name="image"
                              type="file"
                              className="form-control"
                              onChange={(e) => {
                                this.onImageChange(e);
                              }}
                            />
                            {this.state.imageError && (
                              <small style={{ color: "red" }}>
                                {this.state.imageError}
                              </small>
                            )}
                            <span
                              onClick={(e) => {
                                this.openModal();
                              }}
                              className="btn btn-success"
                            >
                              Choose from Avatar
                            </span>
                            <div className="col scoreUserImg">
                              <div className="scoreImgOuter">
                                <img
                                  src={
                                    this.state.image_src
                                      ? base + this.state.image_src
                                      : "data:image/jpeg;base64,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"
                                  }
                                  alt="Avatar"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
                <CardFooter>
                  <Button
                    className="btn-round"
                    color="info"
                    onClick={this.postSignUp}
                  >
                    Save
                  </Button>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Mock);
